/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type DeclinedTradeRow_trade$ref = any;
type PendingTradeRow_trade$ref = any;
export type TradesSubscriptionsUpdatedSubscriptionVariables = {};
export type TradesSubscriptionsUpdatedSubscriptionResponse = {
    readonly tradeUpdated: {
        readonly id: string;
        readonly " $fragmentRefs": PendingTradeRow_trade$ref & DeclinedTradeRow_trade$ref;
    };
};
export type TradesSubscriptionsUpdatedSubscription = {
    readonly response: TradesSubscriptionsUpdatedSubscriptionResponse;
    readonly variables: TradesSubscriptionsUpdatedSubscriptionVariables;
};



/*
subscription TradesSubscriptionsUpdatedSubscription {
  tradeUpdated {
    id
    ...PendingTradeRow_trade
    ...DeclinedTradeRow_trade
  }
}

fragment PendingTradeRow_trade on Trade {
  id
  refNumber
  tradeTimestamp
  company {
    id
    runningBalance
    tradeLimit {
      limit
    }
    info {
      name
    }
  }
  createdBy {
    id
    displayName
  }
  status
  weight
  usdPerTroyOunce
  zarToUsd
  zarPerGram
  requestedZarPerGram
  notes
}

fragment DeclinedTradeRow_trade on Trade {
  id
  tradeTimestamp
  status
  weight
  company {
    id
    info {
      name
    }
  }
  createdBy {
    id
    displayName
  }
  usdPerTroyOunce
  zarToUsd
  zarPerGram
  requestedZarPerGram
  rejection {
    eventTimestamp
    reason
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "subscription",
  "name": "TradesSubscriptionsUpdatedSubscription",
  "id": null,
  "text": "subscription TradesSubscriptionsUpdatedSubscription {\n  tradeUpdated {\n    id\n    ...PendingTradeRow_trade\n    ...DeclinedTradeRow_trade\n  }\n}\n\nfragment PendingTradeRow_trade on Trade {\n  id\n  refNumber\n  tradeTimestamp\n  company {\n    id\n    runningBalance\n    tradeLimit {\n      limit\n    }\n    info {\n      name\n    }\n  }\n  createdBy {\n    id\n    displayName\n  }\n  status\n  weight\n  usdPerTroyOunce\n  zarToUsd\n  zarPerGram\n  requestedZarPerGram\n  notes\n}\n\nfragment DeclinedTradeRow_trade on Trade {\n  id\n  tradeTimestamp\n  status\n  weight\n  company {\n    id\n    info {\n      name\n    }\n  }\n  createdBy {\n    id\n    displayName\n  }\n  usdPerTroyOunce\n  zarToUsd\n  zarPerGram\n  requestedZarPerGram\n  rejection {\n    eventTimestamp\n    reason\n    id\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "TradesSubscriptionsUpdatedSubscription",
    "type": "Subscription",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "tradeUpdated",
        "storageKey": null,
        "args": null,
        "concreteType": "Trade",
        "plural": false,
        "selections": [
          v0,
          {
            "kind": "FragmentSpread",
            "name": "PendingTradeRow_trade",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "DeclinedTradeRow_trade",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "TradesSubscriptionsUpdatedSubscription",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "tradeUpdated",
        "storageKey": null,
        "args": null,
        "concreteType": "Trade",
        "plural": false,
        "selections": [
          v0,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "refNumber",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "tradeTimestamp",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "company",
            "storageKey": null,
            "args": null,
            "concreteType": "Company",
            "plural": false,
            "selections": [
              v0,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "runningBalance",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tradeLimit",
                "storageKey": null,
                "args": null,
                "concreteType": "CompanyTradeLimit",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "limit",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "info",
                "storageKey": null,
                "args": null,
                "concreteType": "CompanyInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "createdBy",
            "storageKey": null,
            "args": null,
            "concreteType": "AuditUser",
            "plural": false,
            "selections": [
              v0,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "displayName",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "weight",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "usdPerTroyOunce",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "zarToUsd",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "zarPerGram",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "requestedZarPerGram",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "notes",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "rejection",
            "storageKey": null,
            "args": null,
            "concreteType": "LatestTradeRejection",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "eventTimestamp",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "reason",
                "args": null,
                "storageKey": null
              },
              v0
            ]
          }
        ]
      }
    ]
  }
};
})();
(node as any).hash = '079308f2fa66b01097b3f1f292694359';
export default node;
